/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { auditGetAll } from '../fn/audit/audit-get-all';
import { AuditGetAll$Params } from '../fn/audit/audit-get-all';
import { DataPageOfListOfAudit } from '../models/data-page-of-list-of-audit';

@Injectable({ providedIn: 'root' })
export class AuditService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `auditGetAll()` */
  static readonly AuditGetAllPath = '/api/Audit';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `auditGetAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  auditGetAll$Response(params?: AuditGetAll$Params, context?: HttpContext): Observable<StrictHttpResponse<DataPageOfListOfAudit>> {
    return auditGetAll(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `auditGetAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  auditGetAll(params?: AuditGetAll$Params, context?: HttpContext): Observable<DataPageOfListOfAudit> {
    return this.auditGetAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<DataPageOfListOfAudit>): DataPageOfListOfAudit => r.body)
    );
  }

}
